export default __webpack_public_path__ + "static/media/LL2.BlueIris.SoftwareApplicationLicense.d37e724b.htm";